module.exports = __webpack_public_path__ + "assets/static/media/logo-2.e630b260.png";